import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../../constants/Options';

interface CategoryMasterFormViewProps {
    handleFormSuccess: () => void;
}
const CategoryMasterCreateView: React.FC<CategoryMasterFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        name: "",
        name_nep: "",
        des: "",
        des_nep: "",
        status: "",
        remarks: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("name_nep", values.name_nep);
            formData.append("des", values.des);
            formData.append("des_nep", values.des_nep);
            formData.append("status", values.status==="1"?"1":"0");
            formData.append("remarks", values.remarks);
            try {
                await postDataToTheServer(AppURL.InventoryURL + 'inventory/product/master/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        action.resetForm();
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message});
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Product Master Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='name'
                            label='Product Master Name'
                            handleChange={handleChange}
                            value={values.name}
                            error={errors.name}
                            handleBlur={handleBlur}
                            touched={touched.name}
                            required={true}
                            placeholder='Enter Master Name'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Product Master Name(Nepali)'
                            name='name_nep'
                            value={values.name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.name_nep}
                            placeholder='Enter Product Master nepali name'
                            touched={touched.name_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='des'
                            label='Product Master Name'
                            handleChange={handleChange}
                            value={values.des}
                            error={errors.des}
                            handleBlur={handleBlur}
                            touched={touched.des}
                            required={false}
                            placeholder='Enter Description'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Desciption Name(Nepali)'
                            name='des_nep'
                            value={values.des_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'des_nep' })}
                            required={false}
                            handleBlur={handleBlur}
                            error={errors.des_nep}
                            placeholder='Enter Product Master Desc nepali'
                            touched={touched.des_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Active'
                            options={YesNoOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={true}
                            placeholder='Select Active/Inactive'
                            name='status'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'status' } });
                            }}
                            value={values.status}
                            touched={touched.status}
                            errors={errors.status}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={errors.remarks}
                            handleBlur={handleBlur}
                            touched={touched.remarks}
                            required={false}
                            placeholder='Enter Remarks'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default CategoryMasterCreateView